import React from 'react';
import styled from 'styled-components';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  save?: boolean; // save 여부를 나타내는 불리언 값
}

const ButtonContainer = styled.button<{ $save?: boolean }>`
  padding: 8px 12px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  background-color: ${(props) =>
    props.$save ? props.theme.colors.subColor : props.theme.colors.redColor};
  &:hover {
    background-color: ${(props) =>
      props.$save
        ? props.theme.colors.subHoverColor
        : props.theme.colors.redHoverColor};
  }

  @media (max-width: 768px) {
    min-width: 30px;
    padding: 5px 15px;
    font-size: 9px;
  }
  @media (max-width: 350px) {
    padding: 5px 12px;
  }
`;

const Button: React.FC<ButtonProps> = ({ children, save, ...props }) => (
  <ButtonContainer $save={save} {...props}>
    {children}
  </ButtonContainer>
);

export default Button;
